import styled from "styled-components";

import { CardContent } from "../Card";

const SurveyOfferCardTitle = styled(CardContent.Title)`
  margin-bottom: 0px;
`;

export { SurveyOfferCardTitle };
